import { render, staticRenderFns } from "./CalculateSalaryProcessBesRobot.vue?vue&type=template&id=23078890&"
import script from "./CalculateSalaryProcessBesRobot.vue?vue&type=script&lang=js&"
export * from "./CalculateSalaryProcessBesRobot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports